import { Component, OnInit,ViewChild } from '@angular/core';
import { WaterTankService } from 'app/shared/services/water-tank.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogConfig } from '@angular/material/dialog';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { NbThemeService } from '@nebular/theme';
import { WaterTankComponent } from '../water-tank/water-tank.component';


@Component({
  selector: 'ngx-water-tank-list',
  templateUrl: './water-tank-list.component.html',
  styleUrls: ['./water-tank-list.component.scss']
})
export class WaterTankListComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'Date', 'Liters', 'CreatedBy','action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  dataList:any;  

  constructor(private waterTankService : WaterTankService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private companyProfileService: CompanyProfileService,
              private themeService: NbThemeService,
             ) { }

  ngOnInit(): void {

    this.getWaterTenkList();

      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });
  }

  newButtonClick(){
   const dialogConfig = new MatDialogConfig();
   dialogConfig.disableClose = true;
   dialogConfig.autoFocus = true;
   dialogConfig.width = "40%";
   this.dialogService.openDialog(WaterTankComponent,dialogConfig)
   .afterClosed().subscribe(res => this.getWaterTenkList());  
  }

  veiwButtonClick(row){
    const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.data = row;
     dialogConfig.width = "40%";
     this.dialogService.openDialog(WaterTankComponent,dialogConfig)
      .afterClosed().subscribe(res => this.getWaterTenkList());

  }


  getWaterTenkList(){
    this.waterTankService.getAll()
     .subscribe(
        (data) => {
                  this.dataList = data;
                  this.dataSource = new  MatTableDataSource (this.dataList);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }


    deleteButtonClick(id : number){
      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.waterTankService.delete(id)
        .subscribe(
          (res) => {
                      this.toastr.success('Record deleted successfully','Success');
                     this.getWaterTenkList();
                      console.log(res);     
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete record','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
  }

  applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

  }
  onSearchClear(){
    this.searchKey = "";
    this.applyFilter();
  }


}//end class
